/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
        suggestionMobileStyle: 'style2',
        //suggestionStyle: 'style3',
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
      // Overide this method for customization
    document.querySelector('#predictive-search').style.display='none'
    document.querySelector('#predictive-search').innerHTML =''
    document.body.classList.remove('predictive-overflow-hidden');
    document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
  }

  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function(isClose) {
      // Overide this method for customization
    document.querySelector('#predictive-search').style.display='none'
    document.querySelector('#predictive-search').innerHTML =''
    document.body.classList.remove('predictive-overflow-hidden');
    document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
  }

InstantSearchResultItemProduct.prototype.afterRender = function() {
    if (this.hasOwnProperty('data') && this.data !== null) {
        var data = this.data;
        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
        var localeURLPart = "";
        if (hasShopifyRoutes) {
            localeURLPart = Shopify.routes.root.replace(/\/$/, '');
        }
        var quickUrl = localeURLPart + '/products/' + data.handle + '?view=boost-pfs-integration';
        console.log(quickUrl)
        jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').empty();
        /*SE-30APRIL'25
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
                try {
                    const res = JSON.parse(result);
             
                    jQ('.boost-pfs-search-suggestion-item[data-id="' + res.id + '"] .boost-pfs-search-suggestion-product-price').html(res.price_collection.trim());
                } catch (error) {
                    console.log(error);
                }
            }
        });
        */
    }
}

})();